import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ProductApi } from '../../api/ProductApi';
import { getPaginatedData } from '../Helper/SliceDataHelper';
import { ERecordLength } from '../../data/Constants';

import type { IAppState } from '../../../types';
import type { IReadProducts } from '../../../types/IRequestTypes';

const initialState: IAppState = {
  productModels: {
    data: null,
    page: 1,
    totalCount: 0,
    limit: ERecordLength.RL15,
    searchKey: '',
  },
};

export const getProductModels = createAsyncThunk(
  'app/getProductModels',
  async (action: IReadProducts) => {
    return await ProductApi.getProductModels(action);
  }
);

const AppSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProductModels.fulfilled, (state, action) => {
      if ('error' in action.payload) {
        state.productModels = {
          ...initialState.productModels,
          searchKey: action.meta.arg.productSearch ?? '',
        };
      } else {
        state.productModels = getPaginatedData(state.productModels, action.payload);
      }
    });
  },
});

export const appSettings = (state: IAppState) => state;

export default AppSlice.reducer;
